// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"26499fa5","703":"9ed614ca","787":"6d43f70d"}[chunkId] + ".chunk.js";
};